import styled from 'styled-components';

const Hr = styled.hr`
  height: 2px;
  color: ${props => props.theme.gray};
  margin: 0;
`;

export default Hr;
